import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const Seo = ({ lang, title, description, slug, schema, children }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          image
          company
          siteUrl
        }
      }
    }
  `)

  const settings = data.site.siteMetadata
  const metaDescription = description || settings.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={`${title} | ${settings.company}`}
    >
      <link
        rel="canonical"
        href={slug === "/" ? settings.siteUrl : `${settings.siteUrl}/${slug}/`}
      />

      <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "Corporation",
          "name": "ShipX",
          "url": "https://www.shipx.com/",
          "logo": "https://www.shipx.com/#logo",
          "sameAs": [
            "https://www.facebook.com/shipxdelivery",
            "https://www.linkedin.com/company/shipxdotcom/"
          ]
        }
      `}</script>

      <meta name="robots" content="index, follow" />

      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={settings.image} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={settings.siteUrl} />
      <meta property="og:site_name" content={settings.title} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={settings.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      {children}
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  title: ``,
  description: ``,
  slug: ``,
  schema: ``,
}

Seo.propTypes = {
  lang: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  slug: PropTypes.string,
  schema: PropTypes.string,
}

export default Seo
